import stDialogClientProfileVersionEdit from './clientProfileVersionEdit.component';
import stDialogDiversificationReferral from './diversificationReferralEdit.component';
import stDialogSelectOption from './selectOption.component';
import stDialogTextEdit from './textEdit.component';
import stDialogUrlEdit from './urlEdit.component';

export default angular
  .module('st.Core.Dialog', [])
  .component('stDialogClientProfileVersionEdit', stDialogClientProfileVersionEdit)
  .component('stDialogDiversificationReferral', stDialogDiversificationReferral)
  .component('stDialogSelectOption', stDialogSelectOption)
  .component('stDialogTextEdit', stDialogTextEdit)
  .component('stDialogUrlEdit', stDialogUrlEdit);
